export default "__VITE_ASSET__cOg6fm72__"